/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

export type ImageRenderer = (typeof ImageRenderer)[keyof typeof ImageRenderer];

export const ImageRenderer = {
    INDIGO: "INDIGO",
    CDK: "CDK",
    RDKIT: "RDKIT",
    COORDGEN: "COORDGEN",
} as const;
